import { autoinject, transient } from "aurelia-dependency-injection";
import { RightShipInspectionModel } from "../../../../../../models/rightship-inspections/rightship-inspections.models";
import { computedFrom } from "aurelia-binding";
import { Reflection } from "../../../../../../utilities/reflection";

@autoinject
@transient()
export class RiskFactorTab {
    
    item:RightShipInspectionModel;
    activate(item:RightShipInspectionModel){
        this.item = item;
    }

    @computedFrom(Reflection.getPropertyPath<RiskFactorTab>(z => z.item),
    Reflection.getPropertyPath<RiskFactorTab>(z => z.item.cargillInspectionDetails))
    get totalRiskRating() {
        if (this.item && this.item.cargillInspectionDetails && this.item.cargillInspectionDetails) {
            const item = this.item.cargillInspectionDetails;

            const result = (item.certificationAndDocumentationProbability *
                item.certificationAndDocumentationSeverity) +
                (item.crewManagementProbability *
                    item.crewManagementSeverity) +
                (item.navigationProbability *
                    item.navigationSeverity) +
                (item.safetyManagementProbability *
                    item.safetyManagementSeverity) +
                (item.pollutionManagementProbability *
                    item.pollutionManagementSeverity) +
                (item.machinerySpacesProbability *
                    item.machinerySpacesSeverity) +
                (item.hullAndDeckItemsProbability *
                    item.hullAndDeckItemsSeverity) +
                (item.cargoAndBallastSystemsProbability *
                    item.cargoAndBallastSystemsSeverity) +
                (item.accommodationProbability *
                    item.accommodationSeverity);

            return result.toFixed(2);
        }
        return "N/A";
    }

    cargillInspectionDetailsAnswerChanged(property: string, isChecked: boolean, newValue?: boolean) {
        if (this.item && this.item.cargillInspectionDetails && this.item.cargillInspectionDetails && isChecked) {
            this.item.cargillInspectionDetails[property] = newValue;
        }
    }
}